
export default {
  props: {
    category: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: false,
    },

    eager: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    getFormatedIndex() {
      if (this.index < 10) return `0${this.index}`;

      return this.index;
    },
  },
};
